/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum ORDER_PROPOSAL_STATUS {
	Waiting = 0,
	Accepted = 1,
	Refused = 2,
}
